import FieldBlock from "../../components/CreateClaim/FieldBlock";
import { FileClaimSteps } from "./types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store/root-reducer";
import { BooleanToYesNo, renderPDFImage } from "../../helper";

function ReviewDetails() {
  const { t } = useTranslation();
  const claim = useSelector((state: RootState) => state.claim);

  return (
    <div className="space-y-5">
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">
          {t(FileClaimSteps.CUSTOMER_INFO)}
        </p>
        <div className="space-y-2 mt-2">
          <FieldBlock label="First Name" value={claim.first_name} />
          <FieldBlock label="Last Name" value={claim.last_name} />
          <FieldBlock label="Email" value={claim.email} />
          <FieldBlock label="Mobile Number" value={claim.phone_number} />
          <FieldBlock label="Address 1" value={claim.address_1} />
          <FieldBlock label="Address 2" value={claim.address_2} />
          <FieldBlock label="City" value={claim.city} />
          <FieldBlock label="State" value={claim.state} />
          <FieldBlock label="Zip" value={claim.zip} />
        </div>
      </div>
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">
          {t(FileClaimSteps.PURCHASE_INFO)}
        </p>
        <div className="space-y-2 mt-2">
          <FieldBlock
            label="Store of Purchase"
            value={claim.store_of_purchase}
          />
          <FieldBlock label="Retailer Phone" value={claim.retailer_phone} />
          <FieldBlock label="Address 1" value={claim.retailer_address_1} />
          <FieldBlock label="Address 2" value={claim.retailer_address_2} />
          <FieldBlock label="City" value={claim.retailer_city} />
          <FieldBlock label="State" value={claim.retailer_state} />
          <FieldBlock label="Zip" value={claim.retailer_zip} />
          <FieldBlock label="Purchase Date" value={claim.purchase_date} />
          <FieldBlock
            label={t("Copy of your invoice")}
            value={claim.invoice_image}
            image
          />
        </div>
      </div>
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">
          {t(FileClaimSteps.DAMAGE_INFO)}
        </p>
        <div className="space-y-2 mt-2">
          <FieldBlock label="Date of Incident" value={claim.date_of_incident} />
          <FieldBlock label="Product Type" value={claim.product_type} />
          <FieldBlock
            label="Did you clean the product?"
            value={BooleanToYesNo(claim.did_you_clean_the_protector_encasement)}
          />
          {["protector", "encasement"].includes(
            claim?.product_type?.toLowerCase()
          ) && (
            <>
              <FieldBlock
                label="Protector/Encasement Stained/Damaged"
                value={BooleanToYesNo(
                  claim.protector_encasement_stained_damaged
                )}
              />
              {claim.protector_encasement_stained_damaged && (
                <FieldBlock
                  label="Type of Stain/Damage(Protector)"
                  value={claim.type_of_stain_damage_protector}
                />
              )}
              <FieldBlock
                label="Mattress Stained/Damaged"
                value={BooleanToYesNo(claim.mattress_stained_damaged)}
              />
              {claim?.mattress_stained_damaged && (
                <>
                  <FieldBlock
                    label="Type of Mattress Stain/Damage"
                    value={claim.type_of_stain_damage}
                  />
                  <FieldBlock
                    label="Estimated Mattress Retail Value (USD)"
                    price
                    value={claim.estimated_mattress_retail_value}
                  />

                  <FieldBlock
                    label="Was the Protector/Encasement on bed during incident?"
                    value={BooleanToYesNo(
                      claim.did_you_clean_the_protector_encasement
                    )}
                  />
                </>
              )}
            </>
          )}
          <FieldBlock label="Product Size" value={claim.product_size} />
          <FieldBlock label="Damage Notes" value={claim.damageNotes} />
        </div>
      </div>
      <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
        <p className="text-black font-semibold text-lg">{t("Documents")}</p>
        <div className="space-y-3 mt-2">
          {claim?.protector_damage_images?.length > 0 && (
            <div>
              <p className="font-medium text-black text-sm">
                {t("Three (3) photos of the stained or damaged product")}
              </p>
              <div className="flex items-center gap-4 mt-1 flex-wrap">
                {claim.protector_damage_images.map(renderPDFImage)}
              </div>
            </div>
          )}
          {claim.mattress_stained_damaged &&
            claim.mattress_damage_images.length > 0 && (
              <div>
                <p className="font-medium text-black text-sm">
                  {t("Three (3) photos of the stained or damaged mattress")}
                </p>
                <div className="flex items-center gap-4 mt-1 flex-wrap">
                  {claim.mattress_damage_images.map(renderPDFImage)}
                </div>
              </div>
            )}
          {claim?.protectall_tag_image && (
            <div>
              <p className="font-medium text-black text-sm">
                {t(
                  "ProtectALL Product Tag Photo: Photo of tag or label on the product with name and date written on it."
                )}
              </p>
              {renderPDFImage(claim?.protectall_tag_image)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReviewDetails;
